import "./styles.scss";
export default function DBModalTitle({ children }) {
    return <div className="db-modal-title">{children}</div>;
}
